import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import HeroSection from "../../Common/HeroSection/HeroSection";
import "./About.css";
import myImg from "../../../img/img.jpg";
import how from "../../../img/how.jpg";
import goal from "../../../img/goal.jpg";

const About = () => {
  return (
    <>
      <HeroSection name={"About Me"}></HeroSection>
      <Container className="my-5">
        <Row>
          <Col md="4" sm="12">
            <img src={myImg} alt="" className="border" />
          </Col>
          <Col md="8" sm="12">
            <Row className="mb-3">
              <h2 className="trainer-section-title2">Abdur Rahman</h2>
              <h3 className="trainer-section-title1">Web Designer</h3>
            </Row>
            <Row>
              <h4>About Me</h4>
              <p className="hero-paragraph">
                Hello, I'm Rahman I'm an enthusiastic, Web Designer. Designing
                and coding have always been my passion since I started working
                with computers 1 years ago. I love to play with code.
              </p>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="text-start mt-5">
            <h4>My Goal </h4>
            <p className="hero-paragraph">
              My All time dream is as full stuck developer. Be{" "}
              <strong>M A R N</strong> developer is my one of the goal.{" "}
            </p>
          </Col>
          <Col>
            <img src={goal} width={"350"} className="img-fluid" alt="" />
          </Col>
        </Row>
        <Row>
          <Col>
            <img src={how} width={"350"} className="img-fluid" alt="" />
          </Col>
          <Col style={{ alignSelf: "center" }}>
            <h4>How I achieve It? </h4>
            <p className="hero-paragraph">
              As you know my passion is play with code. Tough I am nobe. But I
              am hard worker. Though I am hard worker but I would like work as
              smartly. I have a working timeline.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default About;
